import styled, { css } from 'styled-components';
import { Text } from 'view/atoms';
import { Media, TextStylesMobile, TextStylesDesktop } from 'enums';

export const Discount = styled.div`
  width: 100%;
  position: relative;
`;

export const DiscountInfoContainer = styled.div`
  padding: 30px 20px 0;
  border-radius: 12px;
  position: relative;
  bottom: 11px;
  background: ${({ theme }) => theme.colors.background};
  margin-bottom: -11px;
  white-space: pre-line;

  @media ${Media.tablet} {
    padding: 30px 40px 0;
  }

  @media ${Media.notebook} {
    position: relative;
    background: ${({ theme }) => theme.colors.white};
    padding: 40px;
    margin-top: 20px;
    border-radius: 16px;
    margin-bottom: 0;
  }

  @media ${Media.desktop} {
    padding: 60px;
    display: flex;
    justify-content: space-between;
    text-align: justify;
    width: 100%;
  }
`;

export const DiscountPeriodTitle = styled(Text)`
  margin-top: 30px;

  @media ${Media.notebook} {
    margin-top: 40px;
  }
`;

export const DiscountPeriod = styled(Text)`
  margin-top: 12px;
`;

export const DiscountSize = styled(Text)`
  margin-top: 30px;

  @media ${Media.notebook} {
    margin-top: 40px;
  }
`;

export const ContactsContainer = styled.div`
  margin: 30px 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 17px;

  @media ${Media.notebook} {
    padding: 0;
    margin: 40px 0;
    gap: 20px;
  }
`;

export const AboutDiscountHeader = styled(Text)`
  margin-top: 20px;

  @media ${Media.notebook} {
    margin-top: 30px;
  }
`;

export const AboutDiscountDescription = styled(Text)`
  margin-top: 8px;
  line-height: 20px;
  word-break: break-word;
  white-space: pre-wrap;

  @media ${Media.notebook} {
    margin-top: 12px;
    line-height: 23.5px;
  }
`;

export const ContactWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  word-break: break-word;
`;

export const Phone = styled.a`
  ${TextStylesMobile.body}
  color: ${({ theme }) => theme.colors.gray1};

  text-decoration: none;

  @media ${Media.notebook} {
    ${TextStylesDesktop.body}
  }
`;

export const Link = styled.a`
  ${TextStylesMobile.body}
  color: ${({ theme }) => theme.colors.gray1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.yellow1};
  text-decoration: none;
  padding-bottom: 2px;

  @media ${Media.notebook} {
    ${TextStylesDesktop.body}
  }
`;

export const ColumnFirst = styled.div`
  position: relative;
  @media ${Media.desktop} {
    width: 54.3%;
  }
`;

export const ColumnSecond = styled.div`
  position: relative;
  @media ${Media.desktop} {
    width: 42.3%;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  gap: 20px;

  @media ${Media.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }

  @media ${Media.notebook} {
    margin-top: 40px;
  }
`;

export const ChipsContainer = styled.div`
  width: 100%;
  min-height: 30px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;

  margin-top: 14px;

  @media ${Media.notebook} {
    min-height: 40px;
  }
`;

export const LikesContainer = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 700px;
  bottom: 24px;
  right: 12px;
  gap: 10px;

  @media ${Media.tablet} {
    bottom: 32px;
    right: 24px;
  }

  @media ${Media.notebook} {
    bottom: 24px;
    right: 10px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  max-width: none;

  @media ${Media.notebook} {
    max-width: 740px;
  }
`;

export const CustomLayoutStyleForDiscountPage = css`
  padding: 0 0 100px;

  @media ${Media.tablet} {
    padding: 0 0 100px;
  }

  @media ${Media.notebook} {
    padding: 60px 80px 150px 80px;
  }

  @media ${Media.desktop} {
    padding: 32px 120px 150px 32px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const HeaderRowTitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media ${Media.mobile} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 140px;
  align-items: flex-start;
`;

export const FavoriteButtonContainer = styled.div`
  && {
    @media ${Media.notebook} {
      background: #eaeae6;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
      margin: 3px 0 0 24px;
      height: 40px;
      width: 40px;
    }
  }

  @media ${Media.mobile} {
    height: 40px;
    width: 40px;
    margin-top: -3px;
  }

  margin-left: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 1;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${Media.tablet} {
    justify-content: flex-start;
  }
`;
